import { render } from "./AddonsModal.vue?vue&type=template&id=28e51f22&scoped=true"
import script from "./AddonsModal.vue?vue&type=script&lang=js"
export * from "./AddonsModal.vue?vue&type=script&lang=js"

import "./AddonsModal.vue?vue&type=style&index=0&id=28e51f22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e51f22"]])

export default __exports__